export default function (date) {
  if (date != null) {
    return [
      (date.getMonth() + 1),
      String(date.getFullYear()).substr(2, 2)
    ]
      .join('/')
      .padStart(5, '0')
  }

  return '00/00'
}
